





























import { Vue, Component, Prop } from 'vue-property-decorator';
import Input from '@/components/Input.vue';

@Component({
  components: {
    Input,
  },
})
export default class OptionEditor extends Vue {
  @Prop() title: string;
  @Prop() addOptionTitle: string;
  @Prop() options: string[];
  showInput = false;
  inputValue = '';

  get hasOptions(): boolean {
    return !!this.options && this.options.length > 0;
  }

  async openOptionInput() {
    this.showInput = true;
    await this.$nextTick();
    const input = this.$refs.input as Input;
    input.setFocus();
  }

  closeOptionInput(): void {
    this.inputValue = '';
    this.$emit('currentValue', '');
    this.showInput = false;
  }

  handleBlur() {
    if (this.inputValue) {
      this.$emit('addOption', this.inputValue);
      this.closeOptionInput();
    } else {
      this.closeOptionInput();
    }
  }

  addOption(): void {
    if (!this.inputValue) {
      this.openOptionInput();
    } else {
      this.$emit('addOption', this.inputValue);
      this.closeOptionInput();
      this.openOptionInput();
    }
  }

  removeOption(option: string): void {
    this.$emit('removeOption', option);
  }

  handleInput(value: string): void {
    this.$emit('currentValue', value);
    this.inputValue = value;
  }
}
